<template>
  <div>
    <h1 class="header-style">
      Site Manager <br>
      Check-out
    </h1>
    <br>
    <p class="subheader-style">
      Click <font class="next-text">
        'Next'
      </font> to complete the check-out.
    </p>
    <v-stepper
      v-model="userCheckOut"
      light
      class="my-stepper-style"
      elevation="0"
    >
      <v-stepper-header>
        <v-stepper-step
          :complete="userCheckOut > 1"
          step="1"
          color="#000"
        />

        <v-divider />

        <v-stepper-step
          :complete="userCheckOut > 2"
          step="2"
          color="#000"
        />

        <v-divider />

        <v-stepper-step
          :complete="userCheckOut > 3"
          color="#000"
          step="3"
        />
      </v-stepper-header>
    </v-stepper>
    <div>
      <staff-location-verification
        v-if="showLocationVerificationPage"
        :org-settings="orgSettings"
        @verification-completed="toSecondStep"
      />
      <gather-project-progress
        v-if="showProjectProgressPage"
        @project-progress-stored="toThirdStep"
      />
      <review-staff-checkout
        v-if="showStaffCheckOutPage"
        @checkout-completed="checkOutCompleted"
      />
    </div>
  </div>
</template>
  <script>
  import StaffLocationVerification from '../dialogComponents/StaffDialogs/checkout/StaffLocactionVerification.vue';
  import ReviewStaffCheckOut from '../dialogComponents/StaffDialogs/checkout/ReviewStaffCheckOut.vue';
  import GatherProjectProgress from '../dialogComponents/StaffDialogs/checkout/GatherProjectProgress.vue';

  export default {
    name: 'StaffCheckOutPage',
    components: {
      'staff-location-verification': StaffLocationVerification,
      'review-staff-checkout': ReviewStaffCheckOut,
      'gather-project-progress': GatherProjectProgress,
    },
    data () {
      return {
        userCheckOut: 1,
        showLocationVerificationPage: true,
        step1SuccessColor: '',
        step2SuccessColor: '',
        showStaffCheckOutPage: false,
        showProjectProgressPage: false,
      };
    },
    computed: {
      step1Success () {
        return `color:${this.step1SuccessColor}`;
      },
      step2Success () {
        return `color:${this.step2SuccessColor}`;
      },
      activeCheckInDetails () {
        return this.$store.getters['swiftuser/getActiveCheckInDetails'];
      },
      isActiveCheckInDetailsFetched () {
        if (Object.keys(this.activeCheckInDetails).length > 0) {
          return true;
        }
        return false;
      },
      checkOutMethodType () {
        return this.$store.getters['swiftuser/getCheckOutMethodType'];
      },
      orgSettings () {
        return this.$store.getters['organization/getOrganizationSettings'];
      },
    },
    async mounted () {
      await this.fetchActiveCheckInDetails();
      this.loadOnMount();
      this.fetchOrgDetails();
    },
    methods: {
      loadOnMount () {
        if (this.checkOutMethodType === null) {
          this.$router.push({ name: 'CheckOut' });
        }
      },
      async fetchOrgDetails () {
        await this.$store.dispatch('organization/fetchOrganizationSettings', this.activeCheckInDetails);
      },
      async fetchActiveCheckInDetails () {
        this.loading = true;
        await this.$store.dispatch('swiftuser/fetchUsersCurrentCheckInDetails').then(response => {
          if (this.isActiveCheckInDetailsFetched === true) {
            this.loading = false;
            return;
          }
          this.loading = false;
          this.$router.push({ name: 'HomePage' });
        }).catch(() => {
          this.loading = false;
          this.$router.push({ name: 'HomePage' });
        });
      },
      toSecondStep () {
        this.step1SuccessColor = '#00796B';
        this.userCheckOut = 2;
        this.showLocationVerificationPage = false;
        this.showStaffCheckOutPage = false;
        this.showProjectProgressPage = true;
      },
      toThirdStep () {
        this.step2SuccessColor = '#00796B';
        this.userCheckOut = 3;
        this.showLocationVerificationPage = false;
        this.showProjectProgressPage = false;
        this.showStaffCheckOutPage = true;
      },
      checkOutCompleted () {
        this.$router.push({ name: 'HomePage' });
      },
    },
  };
</script>
